<section class="cart-page">

    <div class="container cart-container">

        <div class="cart-wrapper">

            <!-- Cart Header -->
            <div class="cart-header">

                <div>
                    <h3 class="cart-title">
                        {{ pageTitleKey | translate }}
                    </h3>

                    <p class="cart-header-subtitle">
                        {{ 'cart.review_before_continue' | translate }}
                    </p>
                </div>

            </div>


            <!-- Cart Items -->
            <div
                id="cart-items"
                @fadeIn>

                <div
                    class="cart-product-card"
                    *ngFor="let product of products | async"
                    @slide>

                    <div class="cart-product-body">

                        <!-- Product Selection -->
                        <div class="cart-selection">

                            <div class="form-check">
                                <input
                                    class="form-check-input cart-checkbox"
                                    type="checkbox"
                                    [checked]="product.selected"
                                    (change)="onSelectItem(product)">
                            </div>

                        </div>


                        <!-- Product Image -->
                        <div class="cart-product-image-wrapper">

                            <a
                                class="product-image"
                                [title]="product.name"
                                [routerLink]="[
                                    '/products',
                                    (product.name.replace(' ', '') | lowercase),
                                    product.id
                                ]">

                                <img
                                    [alt]="product.name"
                                    [src]="getImageSrc(product.imagePath)"
                                    class="cart-product-image">

                            </a>

                        </div>


                        <!-- Product Information -->
                        <div class="cart-product-info">

                            <a
                                class="cart-product-name"
                                [routerLink]="[
                                    '/products',
                                    (product.name.replace(' ', '') | lowercase),
                                    product.id
                                ]">

                                {{ product.name }}

                            </a>


                            <!-- Unit Price -->
                            <div class="cart-unit-price">

                                <span class="cart-price-label">
                                    {{ 'common.unit_price' | translate }}
                                </span>

                                <span class="cart-price-value">

                                    {{
                                        (
                                            product.price
                                            | tocurrency :product.currency
                                            | async
                                        ).toLocaleString()
                                    }}

                                    {{ displayCurrency | uppercase }}

                                    <span class="cart-measurement">
                                        / {{ product.measurementUnit }}
                                    </span>

                                </span>

                            </div>


                            <!-- Quantity -->
                            <div class="cart-quantity-section">

                                <span class="cart-field-label">
                                    Quantity
                                </span>

                                <div class="qty-control">

                                    <button
                                        type="button"
                                        class="qty-btn"
                                        (click)="decrementQty(product)"
                                        [class.disabled]="product.qty <= 1"
                                        [disabled]="product.qty <= 1"
                                        aria-label="Decrease quantity">

                                        <i class="fas fa-minus"></i>

                                    </button>


                                    <span class="qty-value">
                                        {{ product.qty }}
                                    </span>


                                    <button
                                        type="button"
                                        class="qty-btn"
                                        (click)="incrementQty(product)"
                                        aria-label="Increase quantity">

                                        <i class="fas fa-plus"></i>

                                    </button>

                                </div>

                            </div>

                        </div>


                        <!-- Subtotal -->
                        <div class="cart-product-total">

                            <span class="cart-total-label">
{{ 'common.subtotal' | translate }}
                            </span>

                            <span class="cart-total-value">

                                {{
                                    (
                                        calculateThePrice(product)
                                        | tocurrency :product.currency
                                        | async
                                    ).toLocaleString()
                                }}

                                {{ displayCurrency | uppercase }}

                            </span>

                        </div>


                        <!-- Remove -->
                        <button
                            type="button"
                            class="cart-remove-btn"
                            [title]="'common.remove_item' | translate"
                            (click)="removeProductIntoCat(product)"
                            aria-label="Remove product">

                            <i class="fas fa-trash"></i>

                        </button>

                    </div>

                </div>

            </div>


            <!-- Cart Actions -->
            <div
                class="cart-actions-card"
                *ngIf="!isCartEmpty(products | async)">

                <div class="cart-actions-body">

                    <!-- Select All -->
                    <div class="cart-select-all">

                        <div class="form-check">

                            <input
                                class="form-check-input cart-checkbox"
                                type="checkbox"
                                id="selectAll"
                                (change)="onSelectAll($event)">

                            <label
                                class="form-check-label"
                                for="selectAll">

                                {{ 'cart.select_all' | translate }}

                            </label>

                        </div>

                    </div>


                    <!-- Buttons -->
                    <div class="cart-action-buttons">

                        <a
                            class="cart-shop-btn"
                            [routerLink]="['/products', 'all']">

                            <i class="fas fa-arrow-left"></i>

                            <span>
                                Back to shop
                            </span>

                        </a>


                        <a
                            class="cart-checkout-btn"
                            [title]="'delivery.next' | translate"
                            [routerLink]="['/delivery']">

                            <span>
                                {{ 'delivery.next' | translate }}
                            </span>

                            <i class="fas fa-arrow-right"></i>

                        </a>

                    </div>

                </div>

            </div>


            <!-- Empty Cart -->
            <div
                class="empty-cart-card"
                *ngIf="isCartEmpty(products | async)">

                <div class="empty-cart-content">

                    <div class="empty-cart-icon">
                        <i class="fas fa-shopping-cart"></i>
                    </div>

                    <h4 class="empty-cart-title">
                        {{ 'cart.is_empty' | translate }}
                    </h4>

                    <p class="empty-cart-text">
                      
                    </p>

                    <a
                        class="cart-checkout-btn empty-cart-button"
                        [routerLink]="['/products', 'all']">

                        <i class="fas fa-shopping-bag"></i>

                        <span>
                            Back to shop
                        </span>

                    </a>

                </div>

            </div>

        </div>

    </div>

</section>
